__turbopack_context__.v({
  "faq-block": "_4opQ9W_faq-block",
  "faq-cards": "_4opQ9W_faq-cards",
  "faq-container": "_4opQ9W_faq-container",
  "qa-container": "_4opQ9W_qa-container",
});
